import { compose } from 'redux';
import headersMiddleware from './headers';
import refreshMiddleware from './refresh';
import loginMiddleware from './login';
import postLoginMiddleware from './postlogin';

export default store => next => compose(
    postLoginMiddleware(store),
    refreshMiddleware(store),
    headersMiddleware(store),
    loginMiddleware(store),
)(next);
